import type { AdWidget } from './AdWidget';
import {
    BaseWidgetConfiguration,
    TimelineSlot,
    WidgetType,
    ZodBaseWidgetConfiguration,
} from '../types';
import { ZodGenericWidgetConfigurationDetails } from '../types';
import { z } from 'zod';

//TODO: Move these types and interfaces into class TS file

export interface AdObject {
    adbundleid: number;
    adid: number;
    adname: string;
    assetUrl?: string;
    asset_uuid: string;
    domRendered: boolean;
    /** number of seconds */
    duration: number;

    /** file type of this ad's asset */
    filetype?: string;
    jqWrapperElement?: JQuery<HTMLElement>;
    /** number of times ad has been played */

    //@todo: this is not optional anymore,
    // might have to create a new type when we get the object from the server
    playcount: number;
    saturation: number;
    videoElement?: HTMLVideoElement;
}

export type AdWidgetTimelineSlotParams = {
    ad: AdObject;
};

export type AdWidgetTimelineSlot = TimelineSlot<AdWidgetTimelineSlotParams, AdWidget>;

export const ZodAdWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend({
    adbundles: z.nullable(z.string()),
});

export type AdWidgetConfigurationDetails = z.infer<typeof ZodAdWidgetConfigurationDetails>;

export interface AdWidgetConfiguration extends BaseWidgetConfiguration {
    type: WidgetType.AD;
    config: AdWidgetConfigurationDetails;
}

export const ZodAdWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.AD),
    config: ZodAdWidgetConfigurationDetails,
});

export type AdAssetInformation = {
    type: string; // mimetype
    name: string;
    uuid: string;
    arl: string;
};
